/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Upgrade_BtnInputs */

const en_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const es_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const fr_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à niveau`)
};

const de_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const ja_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップグレード`)
};

const zh_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级`)
};

const ar_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترقية`)
};

const id_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkatkan`)
};

const it_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const ru_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Улучшить тариф`)
};

const pt_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer Upgrade`)
};

const ko_seller_dashboard_upgrade_btn = /** @type {(inputs: Seller_Dashboard_Upgrade_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업그레이드`)
};

/**
* | output |
* | --- |
* | "Upgrade" |
*
* @param {Seller_Dashboard_Upgrade_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_upgrade_btn = /** @type {((inputs?: Seller_Dashboard_Upgrade_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Upgrade_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_upgrade_btn(inputs)
	if (locale === "es") return es_seller_dashboard_upgrade_btn(inputs)
	if (locale === "fr") return fr_seller_dashboard_upgrade_btn(inputs)
	if (locale === "de") return de_seller_dashboard_upgrade_btn(inputs)
	if (locale === "ja") return ja_seller_dashboard_upgrade_btn(inputs)
	if (locale === "zh") return zh_seller_dashboard_upgrade_btn(inputs)
	if (locale === "ar") return ar_seller_dashboard_upgrade_btn(inputs)
	if (locale === "id") return id_seller_dashboard_upgrade_btn(inputs)
	if (locale === "it") return it_seller_dashboard_upgrade_btn(inputs)
	if (locale === "ru") return ru_seller_dashboard_upgrade_btn(inputs)
	if (locale === "pt") return pt_seller_dashboard_upgrade_btn(inputs)
	return ko_seller_dashboard_upgrade_btn(inputs)
});